'use strict';

module.exports = function (method, body) {
  if (typeof method !== 'string') {
    throw new Error('Method must be a string');
  }

  if (method.toLowerCase() !== 'get' && body != null) {
    body = typeof body === 'string' ? body : JSON.stringify(body);
  }

  return body;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/braintree-web/client/request/prep-body.js
// module id = 164
// module chunks = 0